import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-check-list-item-tws',
  templateUrl: './check-list-item-tws.component.html',
  styleUrls: ['./check-list-item-tws.component.css']
})
export class CheckListItemTwsComponent implements OnInit {
    argType;

    argValue;

    public setting?: Setting;

    public itemsListLinksToForms: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.argType = this.stateService.getStateParams()['argtype'];
        this.argValue = this.stateService.getStateParams()['argvalue'];
    }

    private async loadSetting() {
        if (!!this.argType && !!this.argValue) {
            this.setting = (await this.datatask.Post(1565, {
                argtype: this.argType,
                argvalue: this.argValue
            }))[0];
        }
    }

    private async loadLinksToForms() {
        if (!this.setting) return;

        return this.itemsListLinksToForms = await this.datatask.Post(1570, {
            argtype: this.setting.argtype,
            argvalue: this.setting.argvalue
        });
    }

    private async init() {
        await this.loadSetting();
        this.loadLinksToForms();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    webpage_heading: string;
    argtype: string;
    argvalue: string;
}
